import React from 'react';
import { Link } from 'react-router-dom';
import { GALLERIES } from '../utils/galleries';

const Footer = () => (
  <footer className="footer">
    <div className="footer__brand">
      <Link to="/" className="footer__wordmark">
        Jonny Coe
      </Link>
      <p>Adventure, travel, and lifestyle photography.</p>
    </div>
    {[
      ['Galleries', GALLERIES.filter((g) => g.kind === 'gallery')],
      ['Trips', GALLERIES.filter((g) => g.kind === 'trip')],
    ].map(([label, items]) => (
      <nav key={label} className="footer__col" aria-label={label}>
        <span className="label">{label}</span>
        {items.map((g) => (
          <Link key={g.slug} to={g.path}>
            {g.title}
          </Link>
        ))}
      </nav>
    ))}
    <nav className="footer__col" aria-label="Site">
      <span className="label">Site</span>
      <Link to="/work">Work</Link>
      <Link to="/about">About</Link>
      <Link to="/faq">FAQ</Link>
    </nav>
    <p className="footer__legal">&copy; {new Date().getFullYear()} Jonny Coe. All images copyright.</p>
  </footer>
);

export default Footer;
